export const aboutData = {
    title: "About me",
    description1: "Computer Systems Engineer with specialization in web and mobile development, data analysis and digital marketing. I'm a passionate problem solver and a lifelong learner.",
    description2: "Expert in front-end technologies, mobile and web development, software analysis and technical documentation. I'm a quick learner and a team player. Right now I'm trying a hand at AI and data analysis.",
    image: 2
}